import { render, staticRenderFns } from "./SalePricesUnit.vue?vue&type=template&id=6d38fb8d"
import script from "./SalePricesUnit.vue?vue&type=script&lang=js"
export * from "./SalePricesUnit.vue?vue&type=script&lang=js"
import style0 from "./SalePricesUnit.vue?vue&type=style&index=0&id=6d38fb8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports